export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14657.2ac4d4df.jpg";